import { useIsSplitEnabled } from '@buffer-mono/features'

const COMPOSER_ZUSTAND_CREATE_POST_FLAG = 'composer-zustand-create-post'

/**
 * Kill-switch for the create-path read-flip. On: `buildCreatePostInputs`
 * sources a channel's content from `channelVariants` when mirrored, falling
 * back to `Draft` otherwise. Off: every channel reads `Draft`, unchanged.
 */
export function useCreatePostZustandEnabled(): boolean {
  return useIsSplitEnabled(COMPOSER_ZUSTAND_CREATE_POST_FLAG)
}
